import { render, staticRenderFns } from "./Tinting.vue?vue&type=template&id=b41fce6c&scoped=true"
import script from "./Tinting.vue?vue&type=script&lang=js"
export * from "./Tinting.vue?vue&type=script&lang=js"
import style0 from "./Tinting.vue?vue&type=style&index=0&id=b41fce6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41fce6c",
  null
  
)

export default component.exports